export default __webpack_public_path__ + "static/media/databse.1149cbfb.jpg";